/* eslint-disable @typescript-eslint/camelcase */
export default {
  addressForm: {
    placeholders: {
      postalCode_Canada: 'Postal Code',
      state_Canada: 'Province',
    },
    lookUpAddress: {
      title: 'Look up address',
      saveButton: 'OK',
      fields: {
        country: 'Country',
        address: 'Address',
      },
      extra: {
        loading: 'Loading',
        noResults: 'No results',
      },
      alerts: {
        failedFind: 'Failed to retrieve and set address',
        failedRetrieve: 'Failed to find addresses',
      },
    },
  },
  createCustomer: {
    errorText: {
      loyaltyCardNumber: {
        invalid: 'This field must be a valid 7, 8 or 9 digit number',
        checking: 'Checking...',
        alreadyExists: 'Customer card number already exists',
      },
    },
    fields: { language: 'Language', senior: 'Senior' },
    languages: {
      english: 'English',
      french: 'French',
    },
  },
};
